import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { ThumbsUp, ThumbsDown, Send } from 'lucide-react';

export default function FeedbackModal({ open, onClose, type, onSubmit }) {
    const [selectedTags, setSelectedTags] = useState([]);
    const [comment, setComment] = useState('');

    const positiveTags = ["Innovador", "Ágil", "Relevante", "Apropiado para la edad", "Creativo", "Claro"];
    const negativeTags = ["Inexacto", "Aburrido", "Poco claro", "Muy complejo", "Demasiado infantil", "Falta contexto"];

    const currentTags = type === 'up' ? positiveTags : negativeTags;
    const isPositive = type === 'up';

    const toggleTag = (tag) => {
        if (selectedTags.includes(tag)) {
            setSelectedTags(selectedTags.filter(t => t !== tag));
        } else {
            setSelectedTags([...selectedTags, tag]);
        }
    };

    const handleSend = () => {
        onSubmit(selectedTags, comment);
        setSelectedTags([]);
        setComment('');
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="bg-slate-900 border-slate-800 max-w-md text-white shadow-2xl p-6">
                <DialogHeader className="mb-4">
                    <div className="flex items-center gap-3 mb-2">
                        <div className={`p-3 rounded-full ${isPositive ? 'bg-emerald-500/20 text-emerald-400' : 'bg-red-500/20 text-red-400'}`}>
                            {isPositive ? <ThumbsUp size={24} /> : <ThumbsDown size={24} />}
                        </div>
                        <DialogTitle className="text-xl font-bold text-white">
                            {isPositive ? '¡Qué bueno que te sirvió!' : 'Ayudanos a mejorar'}
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-slate-400 text-sm">
                        {isPositive ? '¿Qué es lo que más te gustó de esta dinámica?' : '¿Qué falló al generar esta planificación?'}
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-6">
                    <div className="flex flex-wrap gap-2">
                        {currentTags.map(tag => (
                            <button
                                key={tag}
                                onClick={() => toggleTag(tag)}
                                className={`px-4 py-2 rounded-full text-xs font-semibold transition-all border ${
                                    selectedTags.includes(tag) 
                                    ? (isPositive ? 'bg-emerald-600 border-emerald-500 text-white' : 'bg-red-600 border-red-500 text-white')
                                    : 'bg-slate-800 border-slate-700 text-slate-300 hover:border-slate-500'
                                }`}
                            >
                                {tag}
                            </button>
                        ))}
                    </div>

                    <div className="space-y-2">
                        <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Comentario adicional (opcional)</label>
                        <textarea 
                            rows={3}
                            placeholder="Escribí más detalles acá..."
                            className="w-full bg-slate-950 border border-slate-800 rounded-xl p-3 text-sm focus:border-blue-500 outline-none resize-none transition-all"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                    </div>

                    <button 
                        onClick={handleSend}
                        className={`w-full py-3.5 rounded-xl font-bold transition-all flex items-center justify-center gap-2 ${
                            isPositive ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-red-600 hover:bg-red-700'
                        }`}
                    >
                        <Send size={18}/> Enviar feedback
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
